export const durationToMinutes = (
  hourString: string | Date,
  minutesString: string | Date,
): number => {
  const hourToMinutes = Number(hourString) * 60;
  const minutesToNumber = Number(minutesString);

  const duration = hourToMinutes + minutesToNumber;

  return duration;
};
